import { api } from './api'

const CHARTS_PATH = '/dashboard-kpi-charts'

export async function listDashboardKpiCharts(params) {
  const res = await api.get(CHARTS_PATH, { params })
  return res.data?.data ?? res.data
}

export async function upsertDashboardKpiChart(payload) {
  const res = await api.put(CHARTS_PATH, payload)
  return res.data?.data ?? res.data
}

